import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import swal from "sweetalert";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import MUIDataTable from "mui-datatables";
import { API_URL } from "../../config";
import axios from "axios";
import SaveIcon from "@material-ui/icons/Save";
import Button from "@material-ui/core/Button";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import SettingsBackupRestoreIcon from "@material-ui/icons/SettingsBackupRestore";
import CircularProgress from "@material-ui/core/CircularProgress";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import socketIOClient from 'socket.io-client';

import { pathSpliter, checkAuthBranchWare, sortRecordsNewestFirst } from "../../lib/functions";
import {
  currentRouteSet,
  createdEmailCcNameSet,
  updatedEmailCcNameSet,
  disableRestoreEmailCcNameSet,
} from "../../actions/actions";
import moment from "moment";


const EmailCc = ({
  location,
  currentRouteSet,
  authInfo,
  createdEmailCcNameSet,
  updatedEmailCcNameSet,
  disableRestoreEmailCcNameSet,
}) => {
  const classes = useStyles();
  const [formValues, setFormValues] = useState({
    action: "create",
    email_cc_name: "",
    email_cc_mobile: "",
    email_cc_email: "",
    email_cc_name_id: null,
  });
  const [loadingSave, setLoadingSave] = useState(false);
  const [loadingList, setLoadingList] = useState(false);
  const [emailCCs, setEmailCCs] = useState([]);
  const [emailCCUpdateIndex, setEmailCCUpdateIndex] = useState(-1);


  const nameRef = useRef()
  const phoneRef = useRef()
  const emailRef = useRef()

  const [successMsg, setSuccessMsg] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
    msg: "",
  });

  const { vertical, horizontal, open, msg } = successMsg;
  const handleClose = () => {
    setSuccessMsg({ ...successMsg, open: false });
  };
  // In EmailCc.js
  useEffect(() => {
    const socket = socketIOClient(API_URL, { transports: ["websocket"] });
    socket.on("connect_error", (error) => {
      console.warn("Socket connection unavailable:", error?.message || error);
    });

    socket.on("createdEmailCcName", (data) => {
      if (checkAuthBranchWare(data.user_branch_id)) {
        setEmailCCs(prev => sortRecordsNewestFirst([data.createdRow[0], ...prev]));
        setSuccessMsg({ ...successMsg, msg: data.msg, open: true });
        resetForm();
      }
    });

    socket.on("updatedEmailCcName", (data) => {
      if (checkAuthBranchWare(data.user_branch_id)) {
        setEmailCCs(prev => {
          const updated = [...prev];
          updated[data.index] = data.updatedRow[0];
          return updated;
        });
        setSuccessMsg({ ...successMsg, msg: data.msg, open: true });
        resetForm();
      }
    });

    socket.on("disableRestoreEmailCcName", (data) => {
      if (checkAuthBranchWare(data.user_branch_id)) {
        setEmailCCs(prev => {
          const updated = [...prev];
          updated[data.index] = data.disableRestoreRow[0];
          return updated;
        });
        setSuccessMsg({ ...successMsg, msg: data.msg, open: true });
      }
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    currentRouteSet(pathSpliter(location.pathname, 1));
    getEmailCCs();
  }, []);

  const getEmailCCs = async () => {
    setLoadingList(true);
    try {
      const res = await axios.post(`${API_URL}/api/get-email-cc-names`, null, {
        headers: { "auth-token": authInfo.token },
      });
      setEmailCCs(sortRecordsNewestFirst(res.data.message || []));
    } catch (error) {
      console.error("Error fetching email CCs:", error);
      swal({
        title: "Error loading email CCs",
        text: error.message,
        icon: "error",
      });
    } finally {
      setLoadingList(false);
    }
  };

  // Handle real-time updates
  useEffect(() => {
    if (createdEmailCcNameSet) {
      if (checkAuthBranchWare(createdEmailCcNameSet.user_branch_id)) {
        setEmailCCs(prev => sortRecordsNewestFirst([createdEmailCcNameSet.createdRow[0], ...prev]));
        setSuccessMsg({
          ...successMsg,
          msg: createdEmailCcNameSet.msg,
          open: true,
        });
        resetForm();
      }
    }
  }, [createdEmailCcNameSet]);

  useEffect(() => {
    if (updatedEmailCcNameSet) {
      if (checkAuthBranchWare(updatedEmailCcNameSet.user_branch_id)) {
        setEmailCCs(prev => {
          const updated = [...prev];
          updated[updatedEmailCcNameSet.index] = updatedEmailCcNameSet.updatedRow[0];
          return sortRecordsNewestFirst(updated);
        });
        setSuccessMsg({
          ...successMsg,
          msg: updatedEmailCcNameSet.msg,
          open: true,
        });
        resetForm();
      }
    }
  }, [updatedEmailCcNameSet]);

  useEffect(() => {
    if (disableRestoreEmailCcNameSet) {
      if (checkAuthBranchWare(disableRestoreEmailCcNameSet.user_branch_id)) {
        setEmailCCs(prev => {
          const updated = [...prev];
          updated[disableRestoreEmailCcNameSet.index] = disableRestoreEmailCcNameSet.disableRestoreRow[0];
          return updated;
        });
        setSuccessMsg({
          ...successMsg,
          msg: disableRestoreEmailCcNameSet.msg,
          open: true,
        });
      }
    }
  }, [disableRestoreEmailCcNameSet]);

  const resetForm = () => {
    setFormValues({
      action: "create",
      email_cc_name: "",
      email_cc_mobile: "",
      email_cc_email: "",
      email_cc_name_id: null,
    });
    setEmailCCUpdateIndex(-1);
  };

  const handleFromInput = (e) => {
    const { name, value } = e.target;
    setFormValues(prev => ({ ...prev, [name]: value }));
  };

  const saveFormAction = async () => {
    if (!formValues.email_cc_name.trim()) {
      swal({
        title: "Name is required",
        icon: "warning",
      });
      return;
    }

    if (!formValues.email_cc_email.trim()) {
      swal({
        title: "Email is required",
        icon: "warning",
      });
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.email_cc_email)) {
      swal({
        title: "Invalid email format",
        icon: "warning",
      });
      return;
    }

    if (formValues.email_cc_mobile && formValues.email_cc_mobile.length !== 11) {
      swal({
        title: "Mobile number must be 11 digits",
        icon: "warning",
      });
      return;
    }

    const payload = {
      ...formValues,
      emailCCUpdateIndex: emailCCUpdateIndex,
    };

    setLoadingSave(true);
    try {
      const res = await axios.post(`${API_URL}/api/email-cc-name-cu`, payload, {
        headers: { "auth-token": authInfo.token },
      });

      if (res.data.error) {
        swal({
          title: res.data.message,
          icon: "warning",
        });
        return;
      }
      await getEmailCCs();
      resetForm();
    } catch (error) {
      console.error("Error saving email CC:", error);
      swal({
        title: "Error saving email CC",
        text: error.message,
        icon: "error",
      });
    } finally {
      setLoadingSave(false);
    }
    if (nameRef.current) {
      nameRef.current.focus()
    }

  };

  const emailCCEdit = (rowData, index) => {
    const emailCC = emailCCs[index];
    setFormValues({
      action: "update",
      email_cc_name_id: emailCC.email_cc_name_id,
      email_cc_name: emailCC.email_cc_name,
      email_cc_mobile: emailCC.email_cc_mobile,
      email_cc_email: emailCC.email_cc_email,
    });
    setEmailCCUpdateIndex(index);
  };

  const handleDisableRestore = async (emailCCId, action, index) => {
    if (action === "disable") {
      const willContinue = await swal({
        title: "Are you sure?",
        text: "Do you want to delete this email CC?",
        icon: "warning",
        buttons: ["No", "Yes"],
        dangerMode: true,
      });
      if (!willContinue) return;
    }

    try {
      const res = await axios.post(
        `${API_URL}/api/email-cc-name-disable-restore`,
        {
          email_cc_id: emailCCId,
          email_cc_name_id: emailCCId,
          action,
          actionAlias: action === "disable" ? "d" : "a",
          index,
        },
        { headers: { "auth-token": authInfo.token } }
      );
      if (res?.data?.error) {
        swal({ title: res.data.message || "Failed to update email CC", icon: "warning" });
        return false;
      }
      await getEmailCCs();
    } catch (error) {
      console.error("Error updating status:", error);
      swal({
        title: "Error updating email CC",
        text: error.message,
        icon: "error",
      });
    }
  };

  const ActionOptions = ({ rowData, rowIndex }) => {
    return (
      <div style={{ textAlign: "right" }}>
        {authInfo.role !== "user" && (
          <>
            <EditIcon
              style={{
                cursor: "pointer",
                fontSize: "28px",
                color: "rgb(15, 126, 119)",
              }}
              onClick={() => emailCCEdit(rowData, rowIndex)}
            />
            {rowData[1] === "active" ? (
              <DeleteIcon
                style={{
                  cursor: "pointer",
                  color: "#ff0202",
                  fontSize: "28px",
                }}
                onClick={() => handleDisableRestore(rowData[0], "disable", rowIndex)}
              />
            ) : (
              <SettingsBackupRestoreIcon
                style={{
                  cursor: "pointer",
                  color: "rgb(60, 178, 194)",
                  fontSize: "28px",
                }}
                onClick={() => handleDisableRestore(rowData[0], "restore", rowIndex)}
              />
            )}
          </>
        )}
      </div>
    );
  };

  const columns = [
    { name: "email_cc_name_id", options: { display: "excluded" } },
    { name: "email_cc_name_status", options: { display: "excluded" } },
    {
      name: "SL",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          return tableMeta.rowIndex + 1;
        },
      },
    },
    {
      name: "email_cc_name",
      label: "Name",
      options: { filter: true, sort: true },
    },
    {
      name: "email_cc_mobile",
      label: "Mobile No",
      options: { filter: true, sort: true },
    },
    {
      name: "email_cc_email",
      label: "Email",
      options: { filter: true, sort: true },
    },
    {
      name: "email_cc_status",
      label: "Status",
      options: {
        filter: true,
        sort: true,
        display: false,
      },
    },
    {
      name: "actions",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => (
          <ActionOptions rowData={tableMeta.rowData} rowIndex={tableMeta.rowIndex} />
        ),
      },
    },
  ];

  const options = {
    filterType: "checkbox",
    selectableRows: "none",
    print: false,
    download: false,
  };

  return (
    <div className={classes.root}>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success">
          {msg}
        </Alert>
      </Snackbar>

      <Paper className={classes.paper}>
        <h2 className={classes.pageEntryLabel}>Email CC Management</h2>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <TextField
              inputRef={nameRef}
              fullWidth
              variant="outlined"
              size="small"
              label="Name"
              name="email_cc_name"
              value={formValues.email_cc_name}
              onChange={handleFromInput}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  if (phoneRef.current) {
                    phoneRef.current.focus()
                  }
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              inputRef={phoneRef}
              fullWidth
              variant="outlined"
              size="small"
              label="Mobile Number"
              name="email_cc_mobile"
              value={formValues.email_cc_mobile}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,11}$/.test(value)) {
                  handleFromInput(e);
                }
              }}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  if (emailRef.current) {
                    emailRef.current.focus()
                  }
                }
              }}
              error={formValues.email_cc_mobile.length > 0 && formValues.email_cc_mobile.length !== 11}
              helperText={
                formValues.email_cc_mobile.length > 0 && formValues.email_cc_mobile.length !== 11
                  ? "Must be 11 digits"
                  : ""
              }
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              inputRef={emailRef}
              fullWidth
              variant="outlined"
              size="small"
              label="Email"
              name="email_cc_email"
              value={formValues.email_cc_email}
              onChange={handleFromInput}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  saveFormAction()
                }
              }}
            />
          </Grid>
        </Grid>

        <div style={{ marginTop: 20, textAlign: "center" }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<SaveIcon />}
            disabled={loadingSave}
            onClick={saveFormAction}
          >
            {loadingSave ? <CircularProgress size={24} /> : "Save"}
          </Button>
        </div>
      </Paper>

      <Paper className={classes.paper} style={{ marginTop: 20 }}>
        {loadingList ? (
          <div style={{ textAlign: "center", padding: 20 }}>
            <CircularProgress />
          </div>
        ) : (
          <MUIDataTable
            title="Email CC List"
            data={emailCCs}
            columns={columns}
            options={options}
          />
        )}
      </Paper>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  pageEntryLabel: {
    color: "#3f51b5",
    marginBottom: theme.spacing(2),
  },
}));

const mapStateToProps = (state) => ({
  currentRoute: state.currentRouteReducer,
  authInfo: state.authInfoReducer,
  createdEmailCcNameSet: state.createdEmailCcNameReducer,
  updatedEmailCcNameSet: state.updatedEmailCcNameReducer,
  disableRestoreEmailCcNameSet: state.emailCcNameDisableRestoreReducer,
});

export default connect(mapStateToProps, {
  currentRouteSet,
  createdEmailCcNameSet,
  updatedEmailCcNameSet,
  disableRestoreEmailCcNameSet,
})(EmailCc);
